export const PAGINATION_MAX_ITEMS_COUNT = 30
export const PAGINATION_LIMIT_DEFAULT = 10
export const PAGINATION_LIMIT_LARGE = 30
export const PAGINATION_SEARCH_LIMIT_DEFAULT = 15
export const PAGINATION_LIMIT_HORIZONTAL_DEFAULT = 5
export const PAGINATION_RECOMMENDED_LIMIT_DEFAULT = 10

export const QUERY_PARAMETER = {
  LAST_ID: 'lastId',
  LIMIT: 'limit',
  PLATFORM: 'platform'
}

export const QUERY_PARAMETER_VALUE = {
  [QUERY_PARAMETER.PLATFORM]: 'training-app'
}
